import { apService } from "../services";

const state = {
  items: [],
  item: {},
  loading: true
};

// ACTIONS
const actions = {
  // get the ap by his ID
  GET_AP_BY_ID({ commit }, options) {
    // triger mutation -> loading = true
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apService.getById(options.id).then(
        // fetch success, add collection of  aptemplates to the state
        ap => {
          // if there is still no installer, ap state is "created" and
          // the logged-in user will be the installer one
          if (ap && ap.installer === null) {
            const loggedInUser = JSON.parse(localStorage.getItem("user"));
            acceptProtocol.installer =
              (({ name, id }) => ({ name, id }))(loggedInUser) || {};
          }
          commit("fetchItemSuccess", ap);

          // return resolved promise
          resolve(ap);
        },
        error => {
          commit("getAPFail");
          reject(error);
        }
      );
    });
  },

  // create new ap
  CREATE_AP({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apService.createAP(options).then(
        ap => {
          // return the id of newly created ap
          commit("fetchItemSuccess", ap);
          // route app to show current created app (trigger route)
          // pass the ID of newly created ap
          resolve({ apId: ap.id });
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // update existing ap
  UPDATE_AP({ commit }, options) {

    return new Promise((resolve, reject) => {
      apService.updateAP(options).then(
        ap => {
          commit("fetchItemSuccess", ap);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // get the ap by his ID
  DELETE_AP({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apService.deleteAP(options).then(
        () => {
          commit("removeItem", options.id);
          resolve(true);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  // get all aps
  GET_AP_LIST({ dispatch, commit }, options) {
    // triger mutation -> loading = true
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apService.getList(options).then(
        // fetch success, add collection of  aps to the state
        aps => {
          // commit response data as collection
          commit("fetchItemsSuccess", aps);
          // return resolved promise
          resolve(aps);
        },
        error => {
          //commit("getAPsFail");
          reject(error);
        }
      );
    });
  },

  // lock the ap (delete ap and create COMPLETED_AP)
  // everything has been done - ap = finalized
  FINALIZE_AP({ commit }, options) {
    commit("requestSent");
    return new Promise((resolve, reject) => {
      apService.finalizeAP(options).then(
        finalizedApId => {
          // pass the ID of newly created ap
          resolve(finalizedApId);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  SET_ITEM({ commit }, item) {
    commit("setItem", item);
  },

  SET_ITEMS({ commit }, items) {
    commit("setItems", items);
  }
};

// MUTATIONS
const mutations = {
  setItem(item) {
    state.item = item;
  },
  setItems(items) {
    state.items = items;
  },
  // http request fails
  getAPFail(state) {
    state.loading = false;
    state.item = {};
  },
  // http request sent
  requestSent(state) {
    state.loading = true;
  },
  // single model
  fetchItemSuccess(state, item) {
    state.loading = false;
    state.item = item;
  },
  // colection
  fetchItemsSuccess(state, collection) {
    state.loading = false;
    state.items = collection;
  },

  // remove item from collection by his id
  removeItem(state, id) {
    state.items = state.items.filter(x => {
      return x.id != id;
    })
  }
};

// GETTERS
const getters = {
  isLoading: state => state.loading,
  getAllItems: state => state.items
};

// EXPORT
export const ap = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
